import { useEffect, useState, useRef } from "react";

export function usePoll(fn, intervalMs = 60000, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    let timer;
    const run = async () => {
      try {
        const d = await fn();
        if (mounted.current) { setData(d); setError(null); }
      } catch (e) {
        if (mounted.current) setError(e?.response?.data?.detail || e.message || "Failed");
      } finally {
        if (mounted.current) setLoading(false);
      }
    };
    run();
    timer = setInterval(run, intervalMs);
    return () => { mounted.current = false; clearInterval(timer); };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, error, loading };
}
